
import gql from 'graphql-tag'


const UPDATE_USER =  gql`mutation ($name: name!, $address: String!, $phone: numeric!, $email: String!, $nationality: String!, $gender: String!,
    $idNumber: String!, $picture: String!, $date_of_birth: date!, $tokenId: String!, $inPhone: String!){
                update_user(where: {token_id: {_eq: $tokenId}},
                    
                    _set: {

                        name: $name,
                        address: $address,
                        phone: $phone,
                        in_phone: $inPhone,
                        email: $email,
                        nationality: $nationality,
                        gender: $gender,
                        identification_number: $idNumber,
                        picture: $picture,
                        date_of_birth: $date_of_birth
                    })
                    {
                        affected_rows
                        returning {
                            id    
                            name
                            address
                            phone
                            email
                            nationality
                            gender
                            identification_number
                            picture
                            date_of_birth
                         }
                    }
                }`;


const UPDATE_BRAND =  gql`mutation ($brandId: Int! ,$name: name!, $phone: numeric!, $picture: String!,
      $license: String!){
    update_brand(where: {_and:[
    
        {id: {_eq: $brandId}}
    ]},
        
        _set: {

            name: $name,
            phone: $phone,
            logo: $picture,
            license: $license,
        })
        {
            affected_rows
            returning {
                id    
                name
                phone
                logo
                }
        }
    }`;
    
    

const UPDATE_BUSINESS =  gql`mutation ($businessId: Int! ,$name: name!, $address: String!, $phone: numeric!, $picture: String!,
     $tokenId: String!, $license: String!, $isPrivate: Boolean!, $brandId: Int!){
    update_business(where: {_and:[
    
        {token_id: {_eq: $tokenId}},
        {id: {_eq: $businessId}}
    ]},
        
        _set: {

            name: $name,
            address: $address,
            phone: $phone,
            logo: $picture,
            license: $license,
            is_private: $isPrivate,
            brand_id: $brandId
        })
        {
            affected_rows
            returning {
                id    
                name
                address
                phone
                token_email
                logo
                is_private
                location{
                    name
                    latitude
                    longitude
                    address
                    url
            }
        }
    }
}`;


const UPDATE_BUSINESS_WITH_LOCATION =  gql`mutation ($businessId: Int! ,$name: name!, $address: String!, $phone: numeric!, $picture: String!, $license: String!, $brandId: Int!, $locationId: Int!){
   update_business(where:{id: {_eq: $businessId}},
       
       _set: {
           name: $name,
           address: $address,
           phone: $phone,
           logo: $picture,
           license: $license,
           brand_id: $brandId
           location_id: $locationId
       })
       {
           affected_rows
           returning {
               id    
               name
               address
               phone
               token_email
               logo
               is_private
       }
   }
}`;

const UPDATE_BUSINESS_MERCHANT_ID =  gql`mutation ($businessId: Int!, $merchantId: String!){
    update_business(where:{id: {_eq: $businessId}},
        
        _set: {
            sub_merchant_id: $merchantId
        })
        {
            affected_rows
            returning {
                id    
                name
                address
                phone
                token_email
                logo
                is_private
        }
    }
 }`;


const UPDATE_CLASS =  gql`mutation ($name: name!,  $userId: Int!, $instructorId: Int!,$description: String!, $instructorName: String!,
    $image_1: String!, $image_2: String!, $image_3: String!, $image_4: String!, $level: String!,
    $image_5: String!, $image_6: String!, $image_7: String!, $image_8: String!, $points: Int!, $cash: Int!, $isOnline: Boolean!, $payCash: Boolean!, $payPoints: Boolean!,
    $locationName: name!, $address: String!, $latitude: String!, $longitude: String!, $locationUrl:String!){
   update_class(where: {id: {_eq: $classId}},
       
       _set: {

        name: $name,
        instructor_id: $instructorId,
        description: $description,
        instructor_name: $instructorName,
        image_1: $image_1,
        image_2: $image_2,
        image_3: $image_3,
        image_4: $image_4,
        image_5: $image_5,
        image_6: $image_6,
        image_7: $image_7,
        image_8: $image_8,
        location_id: $locationId,
        points_cost: $points,
        cash_cost: $cash,
        level: $level,
        is_online: $isOnline,
        pay_cash: $payCash,
        pay_points: $payPoints
       })
       {
           affected_rows
           returning {
            id
            name
            location_id
            created_by_user
            instructor_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            token_id
            level
            points_cost
            is_online
            business_id
        }
   }
}`;


const UPDATE_CLASS_WITH_LOCATION =  gql`mutation ($name: name!, $instructorId: Int!, $description: String!, $instructorName: String!,
    $image_1: String!, $image_2: String!, $image_3: String!, $image_4: String!, $level: String!, $classId: Int!,
    $image_5: String!, $image_6: String!, $image_7: String!, $image_8: String!, $points: Int!, $cash: Int!, $isOnline: Boolean!, $payCash: Boolean!, $payPoints: Boolean!,
    $locationId: Int!){
  update_class(where:{id: {_eq: $classId}},
      
      _set: {
          name: $name,
          instructor_id: $instructorId,
          description: $description,
          instructor_name: $instructorName,
          image_1: $image_1,
          image_2: $image_2,
          image_3: $image_3,
          image_4: $image_4,
          image_5: $image_5,
          image_6: $image_6,
          image_7: $image_7,
          image_8: $image_8,
          location_id: $locationId,
          points_cost: $points,
          cash_cost: $cash,
          level: $level,
          is_online: $isOnline,
          pay_cash: $payCash,
          pay_points: $payPoints
      })
      {
          affected_rows
          returning {
            id
            name
            location_id
            created_by_user
            instructor_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            token_id
            level
            points_cost
            is_online
            business_id
    }
  }
}`;

    
//owner_id is business_id
const UPDATE_LOCATION=  gql`mutation ($locationId: Int!,$address: String!, $latitude: String!,
     $longitude: String!, $locationName: name!, $locationUrl: String!, $country: String!, $countryCode: String!){
    update_location(where: {id: {_eq: $locationId}},
        
        _set: {

            name: $locationName,
            latitude: $latitude,
            longitude: $longitude,
            address: $address,
            url:$locationUrl,
            country: $country,
            country_code: $countryCode
        })
        {
            
            affected_rows
            returning{
                id
            }
        }
    }`;

    const UPDATE_LOCATION_WITH_CITY=  gql`mutation ($locationId: Int!,$address: String!, $latitude: String!, $cityId: Int!
        $longitude: String!, $locationName: name!, $locationUrl: String!, $country: String!, $countryCode: String!){
       update_location(where: {id: {_eq: $locationId}},
           
           _set: {
   
               name: $locationName,
               latitude: $latitude,
               longitude: $longitude,
               address: $address,
               url:$locationUrl,
               country: $country,
               country_code: $countryCode,
               city_id: $cityId
           })
           {
               
               affected_rows
               returning{
                   id
               }
           }
       }`;

const UPDATE_LOCATION_BUSINESS_ID=  gql`mutation ($locationId: Int!  $businessId: Int!){
    update_location(where: {id: {_eq: $locationId}},
        
        _set: {

            business_id: $businessId
        })
        {
            
            affected_rows
        }
    }`;


const UPDATE_SLOT =  gql`mutation ($slotId: Int!, $classId: Int!, $instructorId: Int!, $monday: Boolean!, $tuesday: Boolean!, $instructorName: name!,
    $wednesday: Boolean!, $thursday: Boolean!, $friday: Boolean!, $saturday: Boolean!, $sunday: Boolean!, $capacity: Int!
   $startDate: date!, $endDate: date!, $startTime: time!, $endTime: time!, $points: Int!, $link: String!
   $males: Boolean!, $females: Boolean!){
    update_slot(where: {id: {_eq: $slotId}},
        
        _set: {

            class_id: $classId,
            instructor_id: $instructorId,
            instructor_name: $instructorName,
            start_date: $startDate,
            end_date: $endDate,
            start_time: $startTime,
            end_time: $endTime,
            points_cost: $points,
            capacity: $capacity,
            link: $link,
            monday: $monday,
            tuesday: $tuesday,
            wednesday: $wednesday,
            thursday: $thursday,
            friday: $friday,
            saturday: $saturday,
            sunday: $sunday,
            males: $males,
            females: $females
        })
        {
            affected_rows
            returning {
                start_date
                end_date
                start_date
                end_time
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday

                class{
                    id
                    name
                }                                    
            }
    }
}`;

const UPDATE_MINOR_SLOT =  gql`mutation ($slotId: Int!, $instructorId: Int!, $instructorName: name!, $link: String!)
{
    update_slot(where: {id: {_eq: $slotId}},
        
        _set: {

            instructor_id: $instructorId,
            instructor_name: $instructorName,
           
            link: $link,

        })
        {
            affected_rows
            returning {
                start_date
                end_date

                class{
                    id
                    name
                }                                    
            }
        }
}`;


const UPDATE_USER_NOTIFICATION =  gql`mutation ($notificationId: bigint!){
   
    update_user_notification(where: {id: {_eq: $notificationId}},
    _set: {

        read: true,
    })
    {
        affected_rows
        returning {
            
            id
            message
            read                                 
        }
    }
}`

const UPDATE_BUSINESS_NOTIFICATION =  gql`mutation ($notificationId: bigint!){
   
    update_business_notification(where: {id: {_eq: $notificationId}},
    _set: {

        read: true,
    })
    {
        affected_rows
        returning {
            
            id
            message
            read                                 
        }
    }
}`

export default {

    user_update: UPDATE_USER,

    update_brand: UPDATE_BRAND,

    update_business: UPDATE_BUSINESS,

    update_location: UPDATE_LOCATION,

    update_location_with_city: UPDATE_LOCATION_WITH_CITY,

    update_location_business_id: UPDATE_LOCATION_BUSINESS_ID,

    business_update_with_location: UPDATE_BUSINESS_WITH_LOCATION,

    update_class: UPDATE_CLASS,
    
    update_class_with_location: UPDATE_CLASS_WITH_LOCATION,

    update_slot: UPDATE_SLOT,

    update_minor_slot :UPDATE_MINOR_SLOT,

    update_business_Merchant_id: UPDATE_BUSINESS_MERCHANT_ID,

    update_user_notification: UPDATE_USER_NOTIFICATION,

    update_business_notification: UPDATE_BUSINESS_NOTIFICATION
}